import React from 'react';
import classNames from 'classnames';
import { Icon } from '@dotcom/crown-ui';
import { ControlButton } from '../../control-button/control-button';
import { TabItemProps } from '../tabs-types';
import styles from '../tabs.module.scss';

export const TabItem = ({
  buttonRef,
  label,
  selected,
  id,
  index,
  onClick,
  onKeyDown,
  onKeyUp,
  marginLarge = false,
  icon,
}: TabItemProps): React.ReactElement => {
  const listClasses = classNames(
    styles['tab-item'],
    { [styles['tab-item-selected']]: selected },
    { [styles['tab-item--large-content']]: marginLarge },
  );

  const buttonClasses = classNames(styles['tab-item-btn'], selected && styles['tab-item-btn-selected']);

  return (
    <div
      className={listClasses}
      role="tab"
      tabIndex={0}
      aria-selected={selected}
      data-index={`${index}`}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      data-testid={`tab-item-${index}`}
    >
      <ControlButton
        label={label}
        onClick={onClick}
        buttonClass={buttonClasses}
        textClass={styles.label}
        id={id}
        ariaLabel={`${icon} icon button ${label ? label : ''}`}
        key={index}
        ariaControls="tab-content-panel"
        ref={buttonRef}
        tabIndex={selected ? 0 : -1}
      >
        <Icon testId={`icon-${icon}`} name={icon} className={styles.icon} />
      </ControlButton>
    </div>
  );
};
